module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_M5-4d442039aa19e0740f902663d34f96a7.png";